// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M12.83 6.5C12.3 4.28 10.64 2.5 8.5 1.81C7.87 1.61 7.2 1.5 6.5 1.5H4.49C3.67 1.5 3 2.17 3 2.99V12.5C3 13.6 3.9 14.5 5 14.5H11C12.1 14.5 13 13.6 13 12.5V8C13 7.48 12.94 6.98 12.83 6.5ZM8.5 1.81V4.5C8.5 5.6 9.39 6.5 10.5 6.5H12.83',
  'M8 12.3V8.6M6.15 10.45L8 8.6L9.85 10.45',
];
